// extracted by mini-css-extract-plugin
export default {"StudentCodeInput":"StudentCodeInput_StudentCodeInput__v2fJN","Wrapper":"StudentCodeInput_Wrapper__BigDl"};